// UTILITIES
export const FINANCE_LIST = [
    {
        code: 'no_finance',
        paymentPeriod: null,
        service: null,
    },
    {
        code: 'default_15',
        paymentPeriod: 15,
        service: 'default',
    },
    {
        code: 'default_30',
        paymentPeriod: 30,
        service: 'default',
    },
    {
        code: 'default_60',
        paymentPeriod: 60,
        service: 'default',
    },
    {
        code: 'default_90',
        paymentPeriod: 90,
        service: 'default',
    },
    {
        code: 'default_120',
        paymentPeriod: 120,
        service: 'default',
    },
];
export const FINANCE_OPTIONS = FINANCE_LIST.map(option => ({
    key: option.code,
    label: `resource.finance.options.${option.code}`,
}));
